import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { findIndex, find } from 'lodash';
import * as Actions from '../actions';
import LiveStreamButton from './LiveStreamButton';
import SurveyButton from './SurveyButton';
import MarqueeBanner from './MarqueeBanner';
import LiveStreamModal from './LiveStreamModal';
import LiveStreamList from './LiveStreamList';
import SurveyList from './SurveyList';
import SingleLiveStreamBody from './SingleLiveStreamBody';
import SingleSurveyBody from './SingleSurveyBody';
import { getEventId } from '../../shared/configUtils';
import { getLiveStreamsSorted } from '../utils';
import classNames from 'classnames';
import pluralize from 'pluralize';
import ReactTooltip from 'react-tooltip';
const perPage = 100;
class App extends React.Component {
  constructor(props) {
    super(props);
    this.clickedLiveStreamButton = this.clickedLiveStreamButton.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.renderLiveStreamModalBody = this.renderLiveStreamModalBody.bind(this);
    this.showLiveStream = this.showLiveStream.bind(this);
    this.showLiveStreamFromSession = this.showLiveStreamFromSession.bind(this);
    this.goBackToLiveStreams = this.goBackToLiveStreams.bind(this);
    this.modalButtonClicked = this.modalButtonClicked.bind(this);
    this.clickedSurveyButton = this.clickedSurveyButton.bind(this);
    this.surveyModalButtonClicked = this.surveyModalButtonClicked.bind(this);
    this.renderSurveysBody = this.renderSurveysBody.bind(this);
    this.showSurvey = this.showSurvey.bind(this);
    this.updateLiveStreamBannerSize = this.updateLiveStreamBannerSize.bind(this);
    this.loadNextSurveyPage = this.loadNextSurveyPage.bind(this);
    this.loadNextLiveStreamsPage = this.loadNextLiveStreamsPage.bind(this);
    this.liveStreamBannerRef = React.createRef();
    this.state = {
      showLiveStreamModal: false,
      activeLiveStreamIndex: false,
      modalTitle: "All Livestreams",
      modalButtonType: "dismiss",
      liveStreamBannerSize: 0
    }
  }
  componentDidMount() {
    this.updateLiveStreamBannerSize();
    window.addEventListener('showSessionLiveStreamModal', this.showLiveStreamFromSession);
    window.addEventListener('showLiveStreamModal', this.clickedLiveStreamButton);
    window.addEventListener("resize", this.updateLiveStreamBannerSize);
  }

  componentWillUnmount() {
    window.removeEventListener('showSessionLiveStreamModal', this.showLiveStreamFromSession);
    window.removeEventListener('showLiveStreamModal', this.clickedLiveStreamButton);
    window.removeEventListener("resize", this.updateLiveStreamBannerSize);
  }

  updateLiveStreamBannerSize() {
    const node = this.liveStreamBannerRef.current;
    this.setState({ liveStreamBannerSize: node.offsetWidth });
  }
  // move to actions
  goBackToLiveStreams() {
    this.setState({
      activeLiveStreamIndex: false,
      modalTitle: "All Livestreams",
      modalButtonType: "dismiss"
    });
  }
  // move to actions
  showLiveStreamFromId(liveStreamId, buttonType) {
    let index = findIndex(this.props.marqueeItems, { 'id': liveStreamId });
    let liveStream = find(this.props.marqueeItems, { 'id': liveStreamId });
    this.setState({
      activeLiveStreamIndex: index,
      showLiveStreamModal: true,
      modalTitle: liveStream.livestreamable_type + " Livestream",
      modalButtonType: buttonType
    });
  }

  showLiveStream(e) {
    let liveStreamId = parseInt(e.currentTarget.getAttribute("data-live-stream-id"));
    let liveStreamButtonType = e.currentTarget.getAttribute("data-modal-button-type") || "goback";
    this.showLiveStreamFromId(liveStreamId, liveStreamButtonType);
  }

  showLiveStreamFromSession(e) {
    this.showLiveStreamFromId(parseInt(e.detail.liveStreamId), "dismiss");
  }

  showSurvey(e) {
    let surveyId = parseInt(e.currentTarget.getAttribute("data-survey-id"));
    this.props.showSurveyFromId(surveyId, "goback");
  }

  renderLiveStreamModalBody(totalLiveStreams, liveStreamsNow, upcomingLiveStreams, pastLiveStreams) {
    if(totalLiveStreams) {
      if(this.state.activeLiveStreamIndex !== false) {
        return (
          <SingleLiveStreamBody
            liveStream={this.props.marqueeItems[this.state.activeLiveStreamIndex]}
          />
        )
      } else {
        return (
          <LiveStreamList
            liveStreamsNow={liveStreamsNow}
            upcomingLiveStreams={upcomingLiveStreams}
            pastLiveStreams={pastLiveStreams}
            showLiveStream={this.showLiveStream}
          />
        )
      }
    } else {
      return null;
    }
  }

  renderSurveysBody() {
    if(this.props.surveys) {
      if(this.props.activeSurveyIndex !== false) {
        return (
          <SingleSurveyBody
            survey={this.props.surveys[this.props.activeSurveyIndex]}
          />
        )
      } else {
        return (
          <SurveyList
            surveys={this.props.surveys}
            showSurvey={this.showSurvey}
            loading={this.props.loadingSurveys}
            nextPage={this.props.surveyNextPage}
            loadNextSurveyPage={this.loadNextSurveyPage}
          />
        )
      }
    } else {
      return null;
    }
  }

  clickedLiveStreamButton() {
    if(this.props.marqueeItems.length) {
      // show modal
      if(this.props.marqueeItems.length == 1) {
        this.setState({
          showLiveStreamModal: !this.state.showLiveStreamModal,
          activeLiveStreamIndex: 0,
          modalTitle: this.props.marqueeItems[0].livestreamable_type + " Livestream"
        });
      } else {
        this.setState({
          showLiveStreamModal: !this.state.showLiveStreamModal,
          modalTitle: "All Livestreams"
        });
      }
    }
  }

  clickedSurveyButton() {
    this.props.triggerShowSurveyModal();
    if(this.props.surveys.length == 0) {
      this.props.fetchSurveys(getEventId(), 0, perPage);
    }
  }

  loadNextSurveyPage() {
    this.props.fetchSurveys(getEventId(), this.props.surveyNextPage, perPage);
  }

  loadNextLiveStreamsPage() {
    this.props.fetchLiveStreams(getEventId(), this.props.liveStreamNextPage, perPage);
  }

  showSingleLiveStreamModal(index) {
    this.setState({
      showLiveStreamModal: true,
      activeLiveStreamIndex: index
    });
  }

  closeModal() {
    this.setState({
      showLiveStreamModal: false,
      activeLiveStreamIndex: false
    });
  }

  modalButtonClicked() {
    if(this.state.modalButtonType == "goback") {
      this.goBackToLiveStreams();
    } else {
      this.closeModal();
    }
  }

  surveyModalButtonClicked() {
    if(this.props.surveyModalButtonType == "goback") {
      this.props.goBackToSurveys();
    } else {
      this.props.closeSurveyModal();
    }
  }

  render() {
    let {
      loading, marqueeItems,
      surveyCanBeTaken, showSurveyModal,
      surveyModalTitle, surveyModalButtonType
    } = this.props;
    const liveStreamFirstBreakpoint = this.state.liveStreamBannerSize < 625;
    const marqueeBannerClass = classNames({
      "mb-shadow-box marquee-banner-wrapper": true,
      "pt2 mobile-formatting": liveStreamFirstBreakpoint
    });
    const liveStreamButtonWrapperClass = classNames({
      "py2 pr2 text-center live-stream-button-wrapper": true,
      "flexbox-item-small": !liveStreamFirstBreakpoint,
      "flexbox-item": liveStreamFirstBreakpoint
    });
    let { liveStreamsNow, upcomingLiveStreams, pastLiveStreams } = getLiveStreamsSorted(marqueeItems);
    let sortedMarqueeItems = [...liveStreamsNow, ...upcomingLiveStreams,  ...pastLiveStreams]
    return(
      <div className={marqueeBannerClass} ref={this.liveStreamBannerRef}>
        {sortedMarqueeItems.length > 0 && liveStreamFirstBreakpoint &&
          <MarqueeBanner
            loading={loading}
            marqueeItems={sortedMarqueeItems}
            clickedLiveStream={this.showLiveStream}
            wrapperStyle="flexbox-item my0 py1 pl2 mx2 br6 cs-color-black-10-bg live-stream-marquee-wrapper mobile-formatting cs-clickable"
          />
        }
        <div className="flexbox-wrapper main-marquee-wrapper flexbox-justify-center ml2">
          {sortedMarqueeItems.length > 0 &&
            <div className={liveStreamButtonWrapperClass}>
              <LiveStreamButton
                liveStreams={sortedMarqueeItems}
                tooltipText={pluralize("Livestream", sortedMarqueeItems.length)}
                buttonText=""
                clickedButton={this.clickedLiveStreamButton}
              />
            </div>
          }
          {surveyCanBeTaken &&
            <div className={liveStreamButtonWrapperClass + " second"}>
              <SurveyButton
                tooltipText="Survey"
                buttonText=""
                clickedButton={this.clickedSurveyButton}
              />
            </div>
          }
          {sortedMarqueeItems.length > 0 && !liveStreamFirstBreakpoint &&
            <MarqueeBanner
              loading={loading}
              marqueeItems={sortedMarqueeItems}
              clickedLiveStream={this.showLiveStream}
              wrapperStyle="flexbox-item mb1 py1 pl2 br6 cs-color-black-10-bg live-stream-marquee-wrapper cs-clickable"
            />
          }
        </div>
        <LiveStreamModal
          isVisible={this.state.showLiveStreamModal}
          title={this.state.modalTitle}
          closeModal={this.closeModal}
          buttonType={this.state.modalButtonType}
          modalButtonClicked={this.modalButtonClicked}
        >
          {this.renderLiveStreamModalBody(sortedMarqueeItems.length, liveStreamsNow, upcomingLiveStreams, pastLiveStreams)}
        </LiveStreamModal>
        <LiveStreamModal
          isVisible={showSurveyModal}
          title={surveyModalTitle}
          closeModal={this.props.closeSurveyModal}
          buttonType={surveyModalButtonType}
          modalButtonClicked={this.surveyModalButtonClicked}
        >
        {this.renderSurveysBody()}
        </LiveStreamModal>
        <ReactTooltip
          id="marquee-banner-tooltip"
          className="csTooltipSolid"
          html={true}
          place="top"
          effect="solid" />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

const mapStateToProps = state => ({
  errors: state.errors,
  loading: state.loading,
  loadingSurveys: state.loadingSurveys,
  marqueeItems: state.marqueeItems,
  surveyCanBeTaken: state.surveyCanBeTaken,
  showSurveyModal: state.showSurveyModal,
  surveyModalButtonType: state.surveyModalButtonType,
  surveyModalTitle: state.surveyModalTitle,
  activeSurveyIndex: state.activeSurveyIndex,
  surveys: state.surveys,
  surveyNextPage: state.surveyNextPage
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
